import useActive from '../hooks/useActive';
const ActiveProvider = props => {
  return props.children(useActive(props));
};
ActiveProvider.displayName = 'ActiveProvider';
export default ActiveProvider;